// Klaviyo teaser click trigger on announcement bar click
document.addEventListener('DOMContentLoaded', function() {
    function showKlaviyoForm() {
        // Use Klaviyo's official method to open the form
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', 'YuFHBi']);
    }

    document.addEventListener('click', function(event) {
        const slide = event.target.closest('.slideshow__slide.slider__slide');
        if (slide && slide.dataset.id === 'announcement_7PtEMF') {
            showKlaviyoForm();
        }
    });
});
